// @flow

import React from "react";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";

type OwnProps = $Exact<{
  type: "SMS" | "Pager",
  id: number,
  onCancel: Function,
  onSubmit: Function,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class ManagerSmsNotificationDeleteModal extends React.Component<Props> {
  handleSubmit = () => {
    this.props.onSubmit(this.props.id);
  };

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader className="d-flex justify-content-between" toggle={this.props.onCancel}>
          {this.props.t("MANAGER_SMS_PAGER_NOTIFICATION_RULE_DELETE_TITLE", {
            type: this.props.type,
          })}
        </ModalHeader>
        <ModalBody className="d-flex flex-column justify-content-start align-content-center">
          <p className="text-greyish-brown">
            {this.props.t("MANAGER_SMS_PAGER_NOTIFICATION_RULE_DELETE_QUESTION", {
              type: this.props.type,
              id: this.props.id,
            })}
          </p>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onCancel}>
            {this.props.t("CANCEL")}
          </Button>
          <Button onClick={this.handleSubmit} materialIcon="delete_forever">
            {this.props.t("MANAGER_SMS_PAGER_NOTIFICATION_RULE_DELETE_SUBMIT_TEXT", {
              type: this.props.type,
            })}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(ManagerSmsNotificationDeleteModal);
